import { Component, OnInit, Input, EventEmitter, Output, HostListener } from '@angular/core';

@Component({
  selector: 'targeting-container',
  templateUrl: './targeting-container.component.html',
  styleUrls: ['./targeting-container.component.scss']
})
export class TargetingContainerComponent implements OnInit {

  @Input('labelSectionWidth') public labelSectionWidth?: string = '150px';
  @Input('label') public label: string;
  @Input('hideEdit') public hideEdit: boolean = false;
  @Input('hideRemove') public hideRemove: boolean = false;
  @Input('disabled') public disabled: boolean;

  @Output() public onEdit = new EventEmitter<any>();
  @Output() public onRemove = new EventEmitter<any>();

  hideAllButtons: boolean = true;

  constructor() { }

  ngOnInit() {
  }

  onEditButtonClick() {
    this.onEdit.emit();
  }

  onRemoveButtonClick() {
    this.onRemove.emit();
  }

  @HostListener('mouseenter')
  onMouseenter() {
    this.hideAllButtons = false;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hideAllButtons = true;
  }

}
